"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityMethodFilter = activityMethodFilter;
exports.activityStatusFilter = activityStatusFilter;
exports.articleTypeFilter = articleTypeFilter;
exports.bargainColorFilter = bargainColorFilter;
exports.bargainStatusFilter = bargainStatusFilter;
exports.communityAuditStatusFilter = communityAuditStatusFilter;
exports.communityReplyStatusFilter = communityReplyStatusFilter;
exports.communityStatusFilter = communityStatusFilter;
exports.couponTypeFilter = couponTypeFilter;
exports.extractStatusFilter = extractStatusFilter;
exports.extractTypeFilter = extractTypeFilter;
exports.filterCategroyType = filterCategroyType;
exports.filterConfigCategory = filterConfigCategory;
exports.filterEmpty = filterEmpty;
exports.filterShowOrHide = filterShowOrHide;
exports.filterShowOrHideForFormConfig = filterShowOrHideForFormConfig;
exports.filterYesOrNo = filterYesOrNo;
exports.filterYesOrNoIs = filterYesOrNoIs;
exports.formatDate = formatDate;
exports.groupColorFilter = groupColorFilter;
exports.groupStatusFilter = groupStatusFilter;
exports.integralLinkIdFilter = integralLinkIdFilter;
exports.integralLinkTypeFilter = integralLinkTypeFilter;
exports.integralStatusFilter = integralStatusFilter;
exports.keywordStatusFilter = keywordStatusFilter;
exports.onePassTypeFilter = onePassTypeFilter;
exports.payStatusFilter = payStatusFilter;
exports.rechargeTypeFilter = rechargeTypeFilter;
var constants = _interopRequireWildcard(require("@/utils/constants.js"));
var _index = require("@/utils/index");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 公共过滤器
function filterEmpty(val) {
  var _result = '-';
  if (!val) {
    return _result;
  }
  _result = val;
  return _result;
}

// 时间过滤器
function formatDate(time) {
  if (time !== 0) {
    var date = new Date(time * 1000);
    return (0, _index.formatDates)(date, 'yyyy-MM-dd hh:mm');
  }
}
function filterYesOrNo(value) {
  return value ? '是' : '否';
}
function filterShowOrHide(value) {
  return value ? '显示' : '不显示';
}
function filterShowOrHideForFormConfig(value) {
  return value === '‘0’' ? '显示' : '不显示';
}
function filterYesOrNoIs(value) {
  return value ? '否' : '是';
}
function filterCategroyType(value) {
  return constants.categoryType.filter(function (item) {
    return value === item.value;
  })[0].name;
}
function filterConfigCategory(value) {
  return constants.configCategory.filter(function (item) {
    return value === item.value;
  })[0].label;
}

/**
 * @description 公众号回复类型
 */
function keywordStatusFilter(status) {
  var statusMap = {
    text: '文字消息',
    image: '图片消息',
    news: '图文消息',
    voice: '声音消息'
  };
  return statusMap[status];
}

/**
 * @description 优惠券领取方式
 */
function couponTypeFilter(status) {
  var statusMap = {
    1: '手动领取',
    2: '新人券',
    3: '赠送券'
  };
  return statusMap[status];
}

/**
 * @description 文章分类
 */
function articleTypeFilter(status) {
  if (!status) {
    return '';
  }
  var arrayList = JSON.parse(localStorage.getItem('articleClass'));
  if (arrayList.filter(function (item) {
    return Number(status) === Number(item.id);
  }).length < 1) {
    return '';
  }
  return arrayList.filter(function (item) {
    return Number(status) === Number(item.id);
  })[0].name;
}

/**
 * @description 支付状态
 */
function payStatusFilter(status) {
  var statusMap = {
    false: '未支付',
    true: '已支付'
  };
  return statusMap[status];
}

/**
 * @description 提现方式
 */
function extractTypeFilter(status) {
  var statusMap = {
    bank: '银行卡',
    alipay: '支付宝',
    weixin: '微信'
  };
  return statusMap[status];
}

/**
 * @description 充值类型
 */
function rechargeTypeFilter(status) {
  var statusMap = {
    public: '微信公众号',
    h5: '网页支付',
    mini: '小程序',
    wechatIos: '微信Ios',
    wechatAndroid: '微信Android',
    alipay: '支付宝',
    alipayApp: '支付宝App'
  };
  return statusMap[status];
}

/**
 * @description 财务审核状态
 */
function extractStatusFilter(status) {
  var statusMap = {
    '-1': '已拒绝',
    0: '审核中',
    1: '已提现'
  };
  return statusMap[status];
}

/**
 * @description 砍价状态
 */
function bargainStatusFilter(status) {
  var statusMap = {
    1: '进行中',
    2: '未完成',
    3: '已成功'
  };
  return statusMap[status];
}

/**
 * @description 砍价状态
 */
function bargainColorFilter(status) {
  var statusMap = {
    1: '',
    2: 'danger',
    3: 'success'
  };
  return statusMap[status];
}

/**
 * @description 拼团状态
 */
function groupStatusFilter(status) {
  var statusMap = {
    1: '进行中',
    2: '已成功',
    3: '未完成'
  };
  return statusMap[status];
}

/**
 * @description 拼团状态
 */
function groupColorFilter(status) {
  var statusMap = {
    1: '',
    2: 'success',
    3: 'danger'
  };
  return statusMap[status];
}

/**
 * @description 一号通tab值
 */
function onePassTypeFilter(status) {
  var statusMap = {
    sms: '短信',
    copy: '商品采集',
    expr_query: '物流查询',
    expr_dump: '电子面单打印'
  };
  return statusMap[status];
}

/**
 * @description 积分状态
 */
function integralStatusFilter(status) {
  var statusMap = {
    1: '订单创建',
    2: '冻结期',
    3: '完成',
    4: '失效'
  };
  return statusMap[status];
}

/**
 * @description 关联类型
 */
function integralLinkTypeFilter(status) {
  var statusMap = {
    order: '订单',
    refund: '退款',
    sign: '签到',
    system: '系统操作'
  };
  return statusMap[status];
}

/**
 * @description 关联id
 */
function integralLinkIdFilter(status) {
  var statusMap = {
    orderNo: '订单号',
    refundOrderNo: '退款单号',
    0: '-'
  };
  return statusMap[status];
}

/**
 * @description 氛围图、活动边框使用范围类型
 */
function activityMethodFilter(status) {
  var statusMap = {
    0: '全部商品',
    1: '指定商品',
    2: '指定品牌',
    3: '指定商品分类',
    4: '指定商户'
  };
  return statusMap[status];
}

/**
 * @description 秒杀商品活动状态
 *
 */
function activityStatusFilter(status) {
  var statusMap = {
    0: '未开始',
    1: '进行中',
    2: '已结束'
  };
  return statusMap[status];
}

/**
 * @description 社区评论审核状态
 *
 */
function communityStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '已通过',
    2: '已拒绝'
  };
  return statusMap[status];
}

/**
 * @description 社区评论审核状态
 *
 */
function communityReplyStatusFilter(status) {
  var statusMap = {
    1: '开启',
    2: '关闭',
    3: '平台关闭'
  };
  return statusMap[status];
}

/**
 * @description 社区内容审核状态
 *
 */
function communityAuditStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '审核成功',
    2: '审核失败',
    3: '平台关闭'
  };
  return statusMap[status];
}